import './../login.css';
import logo from './../../Image/logo.png'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { DevelopmentUri } from '../../config';

export function Logout() {
  const [vendorPicture, setVendorPicture] = useState('');
  const [supplierName, setSupplierName] = useState('');

  const loginId = localStorage.getItem('login_id');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${DevelopmentUri}/api/Login/GetAllSuppliersDetails/${loginId}`);
        const data = response.data;
        setVendorPicture(data.vendorPicture);
        setSupplierName(data.supplierName);
      } catch (error) {
        console.error('Error fetching supplier details:', error);
      }
    };

    fetchData();
  }, []);
  return (
    <div  className='logobar'>
      <div className='logo'>
        <img src={logo} alt="Logo" className="LogoDesign" style={{width: '4%', height:'6%'}} />
        <p>Bangladesh Coast Guard</p>
      </div>
      <div className='logout'>
        <img src={`http://103.107.184.30/${vendorPicture}`} alt="Pic" />
        <p style={{ padding_left: '1%' }}>{supplierName}</p>
      </div>
    </div>
  );
}
